module.exports = __webpack_public_path__ + "static/media/gate.a8bf0f0b.png";